/**
 * AlphaX staff portals — CS and TS (ticketing v2, plan §7).
 *
 * Mount: <div id="ax-portal" data-portal="cs|ts" data-api="https://script.google.com/…/exec">
 * Needs ax-bizhours.js (BizHours, TicketClocks) loaded first.
 *
 * Everything the server sends that came from a customer or staff member is
 * untrusted: it only reaches the DOM through esc().
 */
(function () {
  'use strict';

  var root = document.getElementById('ax-portal');
  if (!root || !window.BizHours || !window.TicketClocks) return;

  var PORTAL = root.getAttribute('data-portal') === 'ts' ? 'ts' : 'cs';
  var OTHER = PORTAL === 'cs' ? 'ts' : 'cs';
  var API = root.getAttribute('data-api') || '';
  var POLL_MS = 60000;
  var TICK_MS = 30000;
  var TZ = 'America/Puerto_Rico';

  var ARCHIVE_REASONS = ['resolved', 'closed_resolved', 'closed_no_reply', 'closed_spam', 'closed_unpaid_deposit', 'auto_after_return', 'shipped', 'migrated'];
  var TS_IDLE = ['RMA_AWAIT_DIAG_PAY', 'RMA_INBOUND', 'RMA_AWAIT_REPAIR_PAY', 'RMA_OUTBOUND', 'RMA_RETURNED'];
  var TS_ON_HAND = ['RMA_ON_HAND', 'RMA_AWAIT_REPAIR_PAY', 'RMA_REPAIR', 'RMA_RETURN_PREP'];
  var CUSTOMER_CLOCKS = ['customerReply', 'diagPay', 'repairPay', 'postDelivery', 'filesDue'];
  var CONTACT_ICONS = { web: '🌐', email: '✉️', whatsapp: '💬', text: '📱', call: '📞' };
  var SUBCATEGORIES = {
    sales: ['Product Orientation', 'Availability & Where to Buy'],
    support: ['Plug and Play ECU', 'Wire-in ECU', 'AlphaX Accessories', 'Tuning Support', 'Tuning - Base Map Session', 'Tuning - Full Tune Referral'],
  };
  var STORE_URL = 'https://alphaxpr.com';
  var MAX_LABEL_BYTES = 10 * 1024 * 1024;
  var CARRIERS = ['Auto', 'USPS', 'UPS', 'FedEx', 'DHL'];
  var CARRIER_LINKS = {
    USPS: 'https://tools.usps.com/go/TrackConfirmAction?tLabels=',
    UPS: 'https://www.ups.com/track?tracknum=',
    FedEx: 'https://www.fedex.com/fedextrack/?trknbr=',
    DHL: 'https://www.dhl.com/us-en/home/tracking.html?tracking-id=',
    Auto: 'https://t.17track.net/en#nums=',
  };

  /* ───────────── i18n ───────────── */

  var I18N = {
    en: {
      csPortal: 'CS Portal', tsPortal: 'TS Portal', loginTitle: 'Staff login', email: 'Email', password: 'Password',
      logIn: 'Log in', logOut: 'Log out', changePassword: 'Change password', noAccess: 'Your account has no access to this portal.',
      techView: 'Tech View', csView: 'CS View', backToMine: 'Back to my board', complete: 'Complete', search: 'Search',
      sort: 'Sort', sortUrgent: 'Most urgent', sortCreatedAsc: 'Date created ↑', sortCreatedDesc: 'Date created ↓', sortContact: 'Latest contact',
      filterAll: 'All', filterIdle: 'Idle', filterOnHand: 'On hand',
      colIntake: 'Intake', colCs: 'CS', colRma: 'RMA', addIntake: '+ Intake', empty: 'Nothing here',
      legend: 'Legend', readOnlyBoard: 'Read-only view of the {p} board',
      selectTicket: 'Select a ticket to see it here.', loading: 'Loading…', openFull: 'Open full view', close: 'Close', back: '← Back to board',
      readOnly: 'Read-only', readOnlyNote: 'You can view this ticket but not act on it from here.', readOnlyNotesOk: 'You can leave internal notes, but not act on it from here.',
      customer: 'Customer', phone: 'Phone', language: 'Language', type: 'Type', vehicle: 'Vehicle', contactMethod: 'Contact', source: 'Source',
      created: 'Created', description: 'Description', details: 'Details', shipments: 'Shipments', payments: 'Payments', timeline: 'Timeline',
      internal: 'INTERNAL', replyToCustomer: 'Reply to customer', internalNote: 'Internal note', send: 'Send',
      logContact: 'Log contact', logContactHint: 'Record a call/text/WhatsApp/email you had outside the portal (counts as a reply).',
      writeReply: 'Write a reply the customer will see…', writeNote: 'Write a note only staff will see…',
      take: 'Take ticket', sendToTs: 'Send to TS', sendToCs: 'Send back to CS', closeTicket: 'Close ticket', refundIssued: 'Refund issued',
      handoverNote: 'Note for the receiving team (optional, internal)', refundRef: 'Shopify refund reference', confirm: 'Confirm', cancel: 'Cancel',
      editTitle: 'Edit title', save: 'Save', needsAction: 'TS ticket — action needed',
      rma: 'RMA', confirmRma: 'Open an RMA for {id} and send the customer the $100 deposit link?', markPaid: 'Mark paid', paymentKind: 'Payment',
      orderNumber: 'Shopify order # (optional)', kind_deposit: 'Diagnostic deposit ($100)', kind_repair_normal: 'Repair — damage ($75)', kind_repair_extreme: 'Repair — extreme ($175)',
      addInbound: 'Add inbound tracking', addOutbound: 'Add outbound tracking', carrier: 'Carrier', trackingNumber: 'Tracking number', editTracking: 'edit', editTrackingHint: 'Fix a mistyped number or carrier. The customer gets the tracking email again.',
      labelPdf: 'Shipping label PDF (optional, max 10 MB)', pdfOnly: 'The label must be a PDF file up to 10 MB.', markDelivered: 'Mark delivered',
      confirmDelivered: 'Mark {id} as delivered?', fileReport: 'Complete report', reportFallback: 'Report without the form', reportPending: 'The form opens in a new tab. The ticket moves on by itself a minute after you submit it.', reportInterim: 'Use only if the Google Form is not working: no photos/videos are attached.',
      outcome: 'Outcome', outcome_warranty: 'Warranty', outcome_damage: 'Damage', outcome_extreme: 'Extreme damage', outcome_unrepairable: 'Not repairable', outcome_no_issue: 'No issue found', outcome_none: '— none —', editTicket: 'Edit', editTicketHint: 'Corrects the saved data only. No email is sent and the ticket stays in Complete; the change is logged in the timeline.', ed_name: 'Name', ed_email: 'Email', ed_phone: 'Phone', ed_title: 'Title', ed_vehicle: 'Vehicle', ed_reason: 'Close reason', editSaved: 'Saved', reportTitle: 'Report title', findings: 'Description / findings',
      repairComplete: 'Repair complete', confirmRepairComplete: 'Mark the repair of {id} complete?', returnUnrepaired: 'Return unrepaired',
      confirmReturnUnrepaired: 'The repair payment window expired. Return {id} unrepaired (AlphaX pays shipping, deposit forfeited)?',
      depositLink: 'Deposit link', copy: 'Copy', copied: 'Copied.', confirmClose: 'Close {id}?', closeReason: 'Why is it closed?', close_resolved: 'Resolved', close_no_reply: 'No reply from the customer', close_spam: 'Spam / invalid (no email)', closeNote: 'Internal note (optional)', closeHint: 'The customer gets a short "ticket closed" email (not for spam). Closed tickets can\'t be reopened.',
      badgeRefund: 'WARRANTY – REFUND $100', badgeUnrepaired: 'UNREPAIRED RETURN', badgeExtreme: 'EXTREME', badgeUnrepairable: 'NOT REPAIRABLE', badgeNoIssue: 'NO ISSUE FOUND',
      age: 'Age', noClock: 'No clock', due: 'due', archivedReason: 'Archived: {r}',
      newTicket: 'New ticket (+Intake)', name: 'Name', inquiry: 'Category', methodOfContact: 'Method of contact', create: 'Create ticket',
      activeExists: 'This email already has an open ticket: {id}.', openIt: 'Open it', created_ok: 'Ticket {id} created.',
      searchPlaceholder: 'Ticket #, name, email, phone, text…', noResults: 'No results.', loadMore: 'Load more',
      currentPassword: 'Current password', newPassword: 'New password (min 6)', passwordChanged: 'Password changed.',
      stale: 'This ticket changed — refreshed.', sessionExpired: 'Your session expired. Please log in again.', networkError: 'Could not reach the server.',
      optional: 'optional', sales: 'Sales', support: 'Support',
      clock_response: 'Reply due', clock_customerReply: 'Customer reply window', clock_diagPay: 'Deposit window',
      clock_repairPay: 'Repair payment window', clock_diagnosis: 'Diagnosis due', clock_repair: 'Repair due', clock_refund: 'Refund due', clock_postDelivery: 'Auto-archive in',
      owner_cs: 'CS', owner_ts: 'TS', owner_customer: 'Customer',
      reason_resolved: 'Resolved by customer', reason_closed_resolved: 'Closed by CS — resolved', reason_closed_spam: 'Closed by CS — spam / invalid', reason_closed_no_reply: 'Closed — no customer reply', reason_closed_unpaid_deposit: 'Closed — deposit unpaid',
      reason_auto_after_return: 'Auto-archived after return', reason_shipped: 'Shipped back to the customer', reason_migrated: 'Migrated from the old system',
      aura_redPulse: 'Our clock overdue', aura_red: 'Not opened yet', aura_orange: '≤ 6 business hours left', aura_greenFlash: 'Unit on hand — file report',
      aura_green: 'Deposit paid — add tracking', aura_lightBlue: 'Unit on its way to us', aura_purple: 'Repair in progress', aura_amber: 'Ready to ship back',
      aura_darkBlue: 'Unit on its way back', aura_grey: 'Waiting on the customer',
      requestFiles: 'Request log & tune', requestFilesHint: 'The customer is asked (in the chat and by email) to upload their most recent tune (.msq) and at least one datalog (.mlg) on the ticket page within 48 business hours. Informational: it does not block the RMA.',
      requestFilesNote: 'What to log (optional, the customer sees it)', cancelFilesRequest: 'Cancel log request', confirmCancelFiles: 'Cancel the open log request on {id}?',
      logs: 'Logs', logsTitle: 'Logs & tune — {e}', noFiles: 'This customer has not uploaded any files yet.', kind_tune: 'Tune', kind_log: 'Log',
      fromTicket: 'from {id}', openDrive: 'Open in Drive', filesHeld: 'We hold the newest tune and up to 3 logs per customer email. Replaced files move to the "old" folder in Drive.',
      filesRequest: 'Log request', filesRequestedAt: 'Requested {w}', filesGot: 'received', filesMissing: 'missing', badgeFilesRequested: 'LOGS REQUESTED',
      clock_filesDue: 'Log & tune window',
    },
    es: {
      csPortal: 'Portal CS', tsPortal: 'Portal TS', loginTitle: 'Acceso de personal', email: 'Correo', password: 'Contraseña',
      logIn: 'Entrar', logOut: 'Salir', changePassword: 'Cambiar contraseña', noAccess: 'Tu cuenta no tiene acceso a este portal.',
      techView: 'Vista Técnica', csView: 'Vista CS', backToMine: 'Volver a mi tablero', complete: 'Completados', search: 'Buscar',
      sort: 'Orden', sortUrgent: 'Más urgente', sortCreatedAsc: 'Fecha de creación ↑', sortCreatedDesc: 'Fecha de creación ↓', sortContact: 'Último contacto',
      filterAll: 'Todos', filterIdle: 'En espera', filterOnHand: 'En taller',
      colIntake: 'Entrada', colCs: 'CS', colRma: 'RMA', addIntake: '+ Entrada', empty: 'Nada aquí',
      legend: 'Leyenda', readOnlyBoard: 'Vista de solo lectura del tablero {p}',
      selectTicket: 'Selecciona un ticket para verlo aquí.', loading: 'Cargando…', openFull: 'Abrir vista completa', close: 'Cerrar', back: '← Volver al tablero',
      readOnly: 'Solo lectura', readOnlyNote: 'Puedes ver este ticket pero no actuar sobre él desde aquí.', readOnlyNotesOk: 'Puedes dejar notas internas, pero no actuar sobre él desde aquí.',
      customer: 'Cliente', phone: 'Teléfono', language: 'Idioma', type: 'Tipo', vehicle: 'Vehículo', contactMethod: 'Contacto', source: 'Origen',
      created: 'Creado', description: 'Descripción', details: 'Detalles', shipments: 'Envíos', payments: 'Pagos', timeline: 'Historial',
      internal: 'INTERNO', replyToCustomer: 'Responder al cliente', internalNote: 'Nota interna', send: 'Enviar',
      logContact: 'Registrar contacto', logContactHint: 'Registra una llamada/texto/WhatsApp/correo fuera del portal (cuenta como respuesta).',
      writeReply: 'Escribe una respuesta que verá el cliente…', writeNote: 'Escribe una nota solo para el personal…',
      take: 'Tomar ticket', sendToTs: 'Enviar a TS', sendToCs: 'Devolver a CS', closeTicket: 'Cerrar ticket', refundIssued: 'Reembolso emitido',
      handoverNote: 'Nota para el equipo que recibe (opcional, interna)', refundRef: 'Referencia del reembolso en Shopify', confirm: 'Confirmar', cancel: 'Cancelar',
      editTitle: 'Editar título', save: 'Guardar', needsAction: 'Ticket de TS — acción requerida',
      rma: 'RMA', confirmRma: '¿Abrir un RMA para {id} y enviar al cliente el enlace del depósito de $100?', markPaid: 'Marcar pagado', paymentKind: 'Pago',
      orderNumber: 'Orden de Shopify # (opcional)', kind_deposit: 'Depósito de diagnóstico ($100)', kind_repair_normal: 'Reparación — daño ($75)', kind_repair_extreme: 'Reparación — extremo ($175)',
      addInbound: 'Añadir rastreo de entrada', addOutbound: 'Añadir rastreo de salida', carrier: 'Transportista', trackingNumber: 'Número de rastreo', editTracking: 'editar', editTrackingHint: 'Corrige un número o transportista mal escrito. El cliente recibe el correo de rastreo de nuevo.',
      labelPdf: 'Etiqueta de envío PDF (opcional, máx. 10 MB)', pdfOnly: 'La etiqueta debe ser un PDF de hasta 10 MB.', markDelivered: 'Marcar entregado',
      confirmDelivered: '¿Marcar {id} como entregado?', fileReport: 'Completar reporte', reportFallback: 'Reporte sin el formulario', reportPending: 'El formulario abre en otra pestaña. El ticket avanza solo un minuto después de enviarlo.', reportInterim: 'Úsalo solo si el Google Form no funciona: no se adjuntan fotos/videos.',
      outcome: 'Resultado', outcome_warranty: 'Garantía', outcome_damage: 'Daño', outcome_extreme: 'Daño extremo', outcome_unrepairable: 'No reparable', outcome_no_issue: 'Sin falla', outcome_none: '— ninguno —', editTicket: 'Editar', editTicketHint: 'Solo corrige los datos guardados. No se envía correo y el ticket sigue en Completados; el cambio queda en la línea de tiempo.', ed_name: 'Nombre', ed_email: 'Correo', ed_phone: 'Teléfono', ed_title: 'Título', ed_vehicle: 'Vehículo', ed_reason: 'Motivo de cierre', editSaved: 'Guardado', reportTitle: 'Título del reporte', findings: 'Descripción / hallazgos',
      repairComplete: 'Reparación completa', confirmRepairComplete: '¿Marcar la reparación de {id} como completa?', returnUnrepaired: 'Devolver sin reparar',
      confirmReturnUnrepaired: 'Venció el plazo de pago de la reparación. ¿Devolver {id} sin reparar (AlphaX paga el envío, se pierde el depósito)?',
      depositLink: 'Enlace del depósito', copy: 'Copiar', copied: 'Copiado.', confirmClose: '¿Cerrar {id}?', closeReason: '¿Por qué se cierra?', close_resolved: 'Resuelto', close_no_reply: 'El cliente no respondió', close_spam: 'Spam / inválido (sin correo)', closeNote: 'Nota interna (opcional)', closeHint: 'El cliente recibe un correo breve de "ticket cerrado" (no en spam). Los tickets cerrados no se reabren.',
      badgeRefund: 'GARANTÍA – REEMBOLSO $100', badgeUnrepaired: 'DEVOLUCIÓN SIN REPARAR', badgeExtreme: 'EXTREMO', badgeUnrepairable: 'NO REPARABLE', badgeNoIssue: 'SIN FALLA',
      age: 'Edad', noClock: 'Sin reloj', due: 'vence', archivedReason: 'Archivado: {r}',
      newTicket: 'Nuevo ticket (+Entrada)', name: 'Nombre', inquiry: 'Categoría', methodOfContact: 'Método de contacto', create: 'Crear ticket',
      activeExists: 'Este correo ya tiene un ticket abierto: {id}.', openIt: 'Abrirlo', created_ok: 'Ticket {id} creado.',
      searchPlaceholder: 'Ticket #, nombre, correo, teléfono, texto…', noResults: 'Sin resultados.', loadMore: 'Cargar más',
      currentPassword: 'Contraseña actual', newPassword: 'Nueva contraseña (mín. 6)', passwordChanged: 'Contraseña cambiada.',
      stale: 'Este ticket cambió — actualizado.', sessionExpired: 'Tu sesión expiró. Entra de nuevo.', networkError: 'No se pudo conectar al servidor.',
      optional: 'opcional', sales: 'Ventas', support: 'Soporte',
      clock_response: 'Responder antes de', clock_customerReply: 'Plazo de respuesta del cliente', clock_diagPay: 'Plazo del depósito',
      clock_repairPay: 'Plazo de pago de reparación', clock_diagnosis: 'Diagnóstico vence', clock_repair: 'Reparación vence', clock_refund: 'Reembolso vence', clock_postDelivery: 'Auto-archivo en',
      owner_cs: 'CS', owner_ts: 'TS', owner_customer: 'Cliente',
      reason_resolved: 'Resuelto por el cliente', reason_closed_resolved: 'Cerrado por CS — resuelto', reason_closed_spam: 'Cerrado por CS — spam / inválido', reason_closed_no_reply: 'Cerrado — el cliente no respondió', reason_closed_unpaid_deposit: 'Cerrado — depósito sin pagar',
      reason_auto_after_return: 'Auto-archivado tras la devolución', reason_shipped: 'Enviada de vuelta al cliente', reason_migrated: 'Migrado del sistema anterior',
      aura_redPulse: 'Nuestro reloj vencido', aura_red: 'Sin abrir', aura_orange: '≤ 6 horas laborables', aura_greenFlash: 'Unidad en taller — llenar reporte',
      aura_green: 'Depósito pagado — añadir rastreo', aura_lightBlue: 'Unidad en camino a nosotros', aura_purple: 'Reparación en curso', aura_amber: 'Lista para enviar',
      aura_darkBlue: 'Unidad en camino al cliente', aura_grey: 'Esperando al cliente',
      requestFiles: 'Pedir log y tune', requestFilesHint: 'Se le pide al cliente (en el chat y por correo) que suba su tune más reciente (.msq) y al menos un datalog (.mlg) en la página del ticket dentro de 48 horas laborables. Es informativo: no bloquea el RMA.',
      requestFilesNote: 'Qué debe grabar (opcional, lo ve el cliente)', cancelFilesRequest: 'Cancelar pedido de logs', confirmCancelFiles: '¿Cancelar el pedido de logs abierto en {id}?',
      logs: 'Logs', logsTitle: 'Logs y tune — {e}', noFiles: 'Este cliente aún no ha subido archivos.', kind_tune: 'Tune', kind_log: 'Log',
      fromTicket: 'de {id}', openDrive: 'Abrir en Drive', filesHeld: 'Guardamos el tune más reciente y hasta 3 logs por correo de cliente. Los archivos reemplazados pasan a la carpeta "old" en Drive.',
      filesRequest: 'Pedido de logs', filesRequestedAt: 'Pedido {w}', filesGot: 'recibido', filesMissing: 'falta', badgeFilesRequested: 'LOGS PEDIDOS',
      clock_filesDue: 'Plazo de log y tune',
    },
  };

  var STATE_LABELS = {
    en: {
      CS_INTAKE: 'CS Intake', CS_ACTIVE: 'With CS', TS_INTAKE: 'TS Intake', RMA_AWAIT_DIAG_PAY: 'Awaiting deposit',
      RMA_DIAG_PAID: 'Deposit paid', RMA_INBOUND: 'Inbound', RMA_ON_HAND: 'On hand', RMA_AWAIT_REPAIR_PAY: 'Awaiting repair payment',
      RMA_REPAIR: 'Repairing', RMA_RETURN_PREP: 'Ready to ship back', RMA_OUTBOUND: 'Outbound', RMA_RETURNED: 'Returned', ARCHIVED: 'Archived',
    },
    es: {
      CS_INTAKE: 'Entrada CS', CS_ACTIVE: 'Con CS', TS_INTAKE: 'Entrada TS', RMA_AWAIT_DIAG_PAY: 'Esperando depósito',
      RMA_DIAG_PAID: 'Depósito pagado', RMA_INBOUND: 'En camino', RMA_ON_HAND: 'En taller', RMA_AWAIT_REPAIR_PAY: 'Esperando pago de reparación',
      RMA_REPAIR: 'Reparando', RMA_RETURN_PREP: 'Lista para enviar', RMA_OUTBOUND: 'Enviada', RMA_RETURNED: 'Devuelta', ARCHIVED: 'Archivado',
    },
  };

  var EVENT_TEXT = {
    en: {
      created: 'Ticket created', taken: 'Taken by {a}', seen: 'Opened in {p}', sent_to_ts: 'Sent to TS by {a}', sent_to_cs: 'Sent back to CS by {a}',
      rma: 'RMA opened by {a} — deposit link sent', paid_deposit: 'Deposit paid', tracking_in: 'Inbound tracking added: {d}', delivered_in: 'Unit delivered to us',
      report: 'Report filed: {o}', paid_repair: 'Repair fee paid', repair_pay_expired: 'Repair payment window expired — returning unrepaired',
      repair_complete: 'Repair complete', tracking_out: 'Shipped back — archived: {d}', delivered_out: 'Unit delivered back to the customer',
      refund_issued: 'Refund issued by {a} ({d})', closed: 'Closed by {a}', resolved: 'Customer marked the ticket Resolved', auto_archived: 'Auto-archived', reopened: 'Reopened by the customer’s message',
      sla_overdue_alerted: 'Overdue alert sent', tracking_edited: 'Tracking corrected by {a}: {d}', payment_flagged: 'Shopify payment {d} needs review — recorded, ticket not moved', title_edited: 'Title changed by {a}: “{d}”', migrated: 'Imported from the old system', edited: 'Edited by {a}: {d}',
      files_requested: 'Log & tune requested by {a}', files_request_cancelled: 'Log request cancelled by {a}', files_request_expired: 'Log request expired (48 business hours)',
      files_received: 'Requested tune + log received', file_uploaded: 'Customer uploaded {d}',
    },
    es: {
      created: 'Ticket creado', taken: 'Tomado por {a}', seen: 'Abierto en {p}', sent_to_ts: 'Enviado a TS por {a}', sent_to_cs: 'Devuelto a CS por {a}',
      rma: 'RMA abierto por {a} — enlace de depósito enviado', paid_deposit: 'Depósito pagado', tracking_in: 'Rastreo de entrada: {d}', delivered_in: 'Unidad recibida',
      report: 'Reporte: {o}', paid_repair: 'Reparación pagada', repair_pay_expired: 'Venció el pago de reparación — se devuelve sin reparar',
      repair_complete: 'Reparación completada', tracking_out: 'Enviada al cliente — archivado: {d}', delivered_out: 'Unidad entregada al cliente',
      refund_issued: 'Reembolso emitido por {a} ({d})', closed: 'Cerrado por {a}', resolved: 'El cliente marcó el ticket como Resuelto', auto_archived: 'Auto-archivado', reopened: 'Reabierto por un mensaje del cliente',
      sla_overdue_alerted: 'Alerta de vencimiento enviada', tracking_edited: 'Rastreo corregido por {a}: {d}', payment_flagged: 'Pago de Shopify {d} requiere revisión — registrado, el ticket no se movió', title_edited: 'Título cambiado por {a}: “{d}”', migrated: 'Importado del sistema anterior', edited: 'Editado por {a}: {d}',
      files_requested: 'Log y tune pedidos por {a}', files_request_cancelled: 'Pedido de logs cancelado por {a}', files_request_expired: 'Venció el pedido de logs (48 horas laborables)',
      files_received: 'Tune + log pedidos recibidos', file_uploaded: 'El cliente subió {d}',
    },
  };

  /* ───────────── state ───────────── */

  var ls = storage(window.localStorage);
  var ss = storage(window.sessionStorage);

  var S = {
    lang: ls.get('axp_lang') === 'es' ? 'es' : 'en',
    token: ss.get('axp_token_' + PORTAL),
    user: null,
    board: null,          // {tickets, counts, holidays}
    bh: null,
    offset: 0,            // server time − local time
    view: PORTAL,         // board shown: own portal or the other one (read-only)
    selected: null,       // ticketId in the preview / full view
    detail: null,         // full ticket from ticket.get
    detailLoading: false,
    full: false,
    sort: 'urgent',
    tsFilter: 'all',
    mobileCol: 0,
    legendOpen: ls.get('axp_legend') !== 'closed',
    composer: { mode: 'public', text: '', method: 'call', ticketId: null },
    form: null,           // inline action form: {act, ticketId}
    editingTitle: false,
    timers: [],
  };

  function storage(store) {
    return {
      get: function (k) { try { return store.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { store.setItem(k, v); } catch (e) { /* private mode */ } },
      del: function (k) { try { store.removeItem(k); } catch (e) { /* private mode */ } },
    };
  }

  /* ───────────── helpers ───────────── */

  function t(key, vars) {
    var s = (I18N[S.lang] && I18N[S.lang][key]) || I18N.en[key] || key;
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }

  function esc(v) {
    return String(v === undefined || v === null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /** Escaped text with http(s):// and www. links made clickable (new tab). */
  function linkify(v) {
    var text = String(v === undefined || v === null ? '' : v);
    var re = /\b(?:https?:\/\/|www\.)[^\s<>"']+/gi;
    var out = '', last = 0, m;
    while ((m = re.exec(text))) {
      var url = m[0].replace(/[.,;:!?)\]}]+$/, '');
      if (url.indexOf('(') >= 0 && m[0].charAt(url.length) === ')') url += ')';   // keep (…) in wiki-style links
      var href = /^www\./i.test(url) ? 'https://' + url : url;
      out += esc(text.slice(last, m.index)) + '<a class="axp-msg-link" href="' + esc(href) + '" target="_blank" rel="noopener noreferrer nofollow">' + esc(url) + '</a>';
      last = m.index + url.length;
      re.lastIndex = last;
    }
    return out + esc(text.slice(last));
  }

  function now() { return Date.now() + S.offset; }

  function ms(v) { var x = v ? new Date(v).getTime() : 0; return isNaN(x) ? 0 : x; }

  function fmtWhen(v) {
    if (!v) return '';
    return new Intl.DateTimeFormat(S.lang === 'es' ? 'es-PR' : 'en-US', {
      timeZone: TZ, weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
    }).format(new Date(v));
  }

  function stateLabel(s) { return (STATE_LABELS[S.lang] || STATE_LABELS.en)[s] || s; }

  function who(email) { return String(email || '').split('@')[0]; }

  function fmtSize(n) {
    n = Number(n) || 0;
    return n >= 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB';
  }

  function holderOf(state) { return TicketClocks.holderOf(state); }

  function needsCsAction(tk) {
    // A shipped-back (archived) ticket stays with CS while its warranty refund is pending.
    return tk.state === 'RMA_AWAIT_REPAIR_PAY' || tk.refundPending === true || tk.refundPending === 'TRUE';
  }

  /** Mirrors the server's canWrite_ (Tickets.gs). */
  function canWrite(tk, portal) {
    if (tk.state === 'ARCHIVED') return portal === 'cs' && needsCsAction(tk);
    if (tk.state === 'CS_INTAKE') return false;
    if (holderOf(tk.state) === portal) return true;
    return portal === 'cs' && needsCsAction(tk);
  }

  /** Mirrors the server's canNote_: internal notes on an open ticket the other team holds. */
  function canNote(tk, portal) {
    var holder = holderOf(tk.state);
    return !!holder && holder !== portal;
  }

  function clocksOf(tk) {
    return S.bh ? TicketClocks.compute(tk, now(), S.bh) : [];
  }

  function fmtClock(c) { return BizHours.format(c.remainingMs); }

  /** Card highlight, highest priority first (plan §4.4), from the point of view of board portal p. */
  function auraOf(tk, p, clocks) {
    var ours = TicketClocks.mostUrgent(clocks, p);
    if (ours && ours.overdue) return 'redPulse';
    if (TicketClocks.isUnseen(tk, p)) return 'red';
    if (ours && ours.warn) return 'orange';
    var byState = { RMA_ON_HAND: 'greenFlash', RMA_DIAG_PAID: 'green', RMA_INBOUND: 'lightBlue', RMA_REPAIR: 'purple', RMA_RETURN_PREP: 'amber', RMA_OUTBOUND: 'darkBlue' };
    if (byState[tk.state]) return byState[tk.state];
    if (tk.state === 'RMA_RETURNED' || clocks.some(function (c) { return CUSTOMER_CLOCKS.indexOf(c.name) >= 0; })) return 'grey';
    return '';
  }

  function typeLabel(tk) {
    return tk.subCategory || (tk.inquiryType === 'sales' ? t('sales') : t('support'));
  }

  /* ───────────── API ───────────── */

  function api(action, params) {
    var body = Object.assign({ action: action, token: S.token || undefined }, params || {});
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); }, function () { throw apiError(t('networkError'), 'network'); })
      .then(function (json) {
        if (json.ok) return json.data;
        var err = apiError(json.error || 'Error', json.code, json.data);
        if (json.code === 'auth_required' && S.user) {
          logoutLocal();
          toast(t('sessionExpired'), 'error');
        }
        throw err;
      });
  }

  function apiError(message, code, data) {
    var e = new Error(message);
    e.code = code;
    e.data = data;
    return e;
  }

  /** Runs a ticket write, then refreshes board + open ticket. Stale → refresh with a notice. */
  function act(action, params, okMsg) {
    var p = Object.assign({ portal: PORTAL }, params);
    return api(action, p).then(function (data) {
      if (okMsg) toast(okMsg, 'ok');
      return refresh().then(function () { return data; });
    }, function (err) {
      if (err.code === 'stale') {
        toast(t('stale'), 'warn');
        refresh();
      } else if (err.code !== 'auth_required') {
        toast(err.message, 'error');
      }
      throw err;
    });
  }

  /* ───────────── data loading ───────────── */

  function loadBoard() {
    return api('board.get', { portal: PORTAL }).then(function (data) {
      S.offset = ms(data.serverTime) - Date.now();
      S.board = data;
      S.bh = BizHours.create(data.holidays);
      renderBoard();
      renderToolbar();
    });
  }

  function loadDetail(id) {
    var wanted = id || S.selected;
    if (!wanted) return Promise.resolve();
    if (!S.detail || S.detail.ticketId !== wanted) S.detailLoading = true;
    renderDetail();
    return api('ticket.get', { portal: PORTAL, ticketId: wanted }).then(function (data) {
      if (S.selected !== wanted) return;
      S.detail = data.ticket;
      S.detailLoading = false;
      renderDetail();
      markSeen(data.ticket);
    }, function (err) {
      S.detailLoading = false;
      if (err.code !== 'auth_required') toast(err.message, 'error');
      renderDetail();
    });
  }

  function refresh() {
    var jobs = [loadBoard()];
    if (S.selected) jobs.push(loadDetail());
    return Promise.all(jobs).catch(function () { /* already reported */ });
  }

  /** "Unseen" clears when someone in this portal opens a ticket in this portal's Intake. */
  function markSeen(tk) {
    if (S.view !== PORTAL || !TicketClocks.isUnseen(tk, PORTAL)) return;
    api('ticket.seen', { portal: PORTAL, ticketId: tk.ticketId }).then(function () {
      var b = boardTicket(tk.ticketId);
      var stamp = new Date(now()).toISOString();
      if (b) b[PORTAL === 'cs' ? 'seenCsAt' : 'seenTsAt'] = stamp;
      if (S.detail && S.detail.ticketId === tk.ticketId) S.detail[PORTAL === 'cs' ? 'seenCsAt' : 'seenTsAt'] = stamp;
      renderBoard();
    }, function () { /* not important enough to report */ });
  }

  function boardTicket(id) {
    if (!S.board) return null;
    for (var i = 0; i < S.board.tickets.length; i++) if (S.board.tickets[i].ticketId === id) return S.board.tickets[i];
    return null;
  }

  /** Poll: board every 60 s while visible; the open ticket only when it changed. */
  function poll() {
    if (document.hidden || !S.user) return;
    var before = S.selected && boardTicket(S.selected);
    var beforeAt = before ? before.updatedAt : null;
    loadBoard().then(function () {
      if (!S.selected) return;
      var after = boardTicket(S.selected);
      if (!after || after.updatedAt !== beforeAt || (S.detail && S.detail.updatedAt !== after.updatedAt)) loadDetail();
    }).catch(function () { /* reported in api() */ });
  }

  function startTimers() {
    stopTimers();
    S.timers.push(setInterval(poll, POLL_MS));
    S.timers.push(setInterval(function () { renderBoard(); renderClocks(); }, TICK_MS));
  }

  function stopTimers() {
    S.timers.forEach(clearInterval);
    S.timers = [];
  }

  document.addEventListener('visibilitychange', function () { if (!document.hidden) poll(); });

  /* ───────────── auth ───────────── */

  function boot() {
    root.innerHTML = '';
    if (!API) {
      root.innerHTML = '<div class="axp-fatal">Backend URL missing (section setting “Tickets backend URL”).</div>';
      return;
    }
    if (!S.token) return renderLogin();
    api('auth.me', {}).then(function (data) {
      onLoggedIn(data.user);
    }, function () {
      S.token = null;
      ss.del('axp_token_' + PORTAL);
      renderLogin();
    });
  }

  function onLoggedIn(user) {
    if (user.permissions.indexOf(PORTAL) < 0) {
      renderLogin(t('noAccess'));
      return;
    }
    S.user = user;
    S.sort = ls.get('axp_sort_' + user.email) || 'urgent';
    S.tsFilter = ls.get('axp_tsfilter_' + user.email) || 'all';
    renderShell();
    var deep = new URLSearchParams(location.search).get('ticket');
    loadBoard().then(function () {
      if (deep) openTicket(deep.toUpperCase(), true, false);
    }).catch(function () { /* reported */ });
    startTimers();
  }

  function logoutLocal() {
    stopTimers();
    S.token = null;
    S.user = null;
    S.board = null;
    S.selected = null;
    S.detail = null;
    S.full = false;
    ss.del('axp_token_' + PORTAL);
    renderLogin();
  }

  /* ───────────── rendering: login & shell ───────────── */

  function renderLogin(message) {
    root.className = 'axp axp-is-login';
    root.innerHTML =
      '<form class="axp-login" data-form="login">' +
        '<div class="axp-brand"><span class="axp-logo">ALPHAX</span> ' + esc(t(PORTAL + 'Portal')) + '</div>' +
        '<h2>' + esc(t('loginTitle')) + '</h2>' +
        '<label>' + esc(t('email')) + '<input name="email" type="email" autocomplete="username" required></label>' +
        '<label>' + esc(t('password')) + '<input name="password" type="password" autocomplete="current-password" required></label>' +
        '<div class="axp-error" role="alert">' + esc(message || '') + '</div>' +
        '<button class="axp-btn axp-btn-primary" type="submit">' + esc(t('logIn')) + '</button>' +
        '<button class="axp-link" type="button" data-act="lang">' + (S.lang === 'en' ? 'Español' : 'English') + '</button>' +
      '</form>';
  }

  function renderShell() {
    root.className = 'axp';
    root.innerHTML =
      '<header class="axp-header">' +
        '<div class="axp-brand"><span class="axp-logo">ALPHAX</span> <span>' + esc(t(PORTAL + 'Portal')) + '</span></div>' +
        '<div class="axp-header-right">' +
          '<span class="axp-user">' + esc(S.user.name || S.user.email) + '</span>' +
          '<button class="axp-btn axp-btn-ghost" data-act="lang">' + (S.lang === 'en' ? 'ES' : 'EN') + '</button>' +
          '<button class="axp-btn axp-btn-ghost" data-act="password">' + esc(t('changePassword')) + '</button>' +
          '<button class="axp-btn axp-btn-ghost" data-act="logout">' + esc(t('logOut')) + '</button>' +
        '</div>' +
      '</header>' +
      '<div class="axp-toolbar" data-region="toolbar"></div>' +
      '<div class="axp-legend" data-region="legend"></div>' +
      '<main class="axp-main">' +
        '<section class="axp-board" data-region="board"></section>' +
        '<aside class="axp-detail" data-region="detail"></aside>' +
      '</main>' +
      '<div class="axp-modal-host" data-region="modal"></div>' +
      '<div class="axp-toasts" data-region="toasts" aria-live="polite"></div>';
    renderToolbar();
    renderLegend();
    renderBoard();
    renderDetail();
  }

  function region(name) { return root.querySelector('[data-region="' + name + '"]'); }

  function renderToolbar() {
    var el = region('toolbar');
    if (!el) return;
    var cross = S.view !== PORTAL;
    var crossLabel = PORTAL === 'cs' ? t('techView') : t('csView');
    var sorts = ['urgent', 'createdAsc', 'createdDesc', 'contact'];
    var sortNames = { urgent: 'sortUrgent', createdAsc: 'sortCreatedAsc', createdDesc: 'sortCreatedDesc', contact: 'sortContact' };
    var html =
      '<button class="axp-btn ' + (cross ? 'axp-btn-primary' : '') + '" data-act="toggleView">' + esc(cross ? t('backToMine') : crossLabel) + '</button>' +
      '<button class="axp-btn" data-act="complete">' + esc(t('complete')) + (S.board ? ' <span class="axp-count">' + S.board.counts.archived + '</span>' : '') + '</button>' +
      '<button class="axp-btn" data-act="search">⌕ ' + esc(t('search')) + '</button>' +
      '<label class="axp-sort">' + esc(t('sort')) + ' <select data-change="sort">' +
        sorts.map(function (s) { return '<option value="' + s + '"' + (S.sort === s ? ' selected' : '') + '>' + esc(t(sortNames[s])) + '</option>'; }).join('') +
      '</select></label>';
    if (S.view === 'ts') {
      html += '<div class="axp-radio" role="radiogroup">' + ['all', 'idle', 'onHand'].map(function (f) {
        var key = 'filter' + f.charAt(0).toUpperCase() + f.slice(1);
        return '<label><input type="radio" name="axp-tsfilter" value="' + f + '" data-change="tsFilter"' + (S.tsFilter === f ? ' checked' : '') + '> ' + esc(t(key)) + '</label>';
      }).join('') + '</div>';
    }
    if (cross) html += '<span class="axp-readonly-tag">' + esc(t('readOnlyBoard', { p: S.view.toUpperCase() })) + '</span>';
    el.innerHTML = html;
  }

  function renderLegend() {
    var el = region('legend');
    if (!el) return;
    var auras = ['redPulse', 'red', 'orange', 'greenFlash', 'green', 'lightBlue', 'purple', 'amber', 'darkBlue', 'grey'];
    el.className = 'axp-legend' + (S.legendOpen ? ' is-open' : '');
    el.innerHTML =
      '<button class="axp-legend-toggle" data-act="legend" aria-expanded="' + S.legendOpen + '">' + esc(t('legend')) + ' ' + (S.legendOpen ? '▴' : '▾') + '</button>' +
      (S.legendOpen ? '<ul>' + auras.map(function (a) {
        return '<li><span class="axp-swatch aura-' + a + '"></span>' + esc(t('aura_' + a)) + '</li>';
      }).join('') + '</ul>' : '');
  }

  /* ───────────── rendering: board ───────────── */

  function columnsFor(p) {
    if (p === 'cs') {
      return [
        { key: 'intake', title: t('colIntake'), test: function (x) { return x.state === 'CS_INTAKE'; } },
        { key: 'cs', title: t('colCs'), test: function (x) { return x.state === 'CS_ACTIVE' || needsCsAction(x); } },
      ];
    }
    return [
      { key: 'intake', title: t('colIntake'), test: function (x) { return x.state === 'TS_INTAKE'; } },
      { key: 'rma', title: t('colRma'), test: function (x) {
        if (x.state.indexOf('RMA_') !== 0) return false;
        if (S.tsFilter === 'idle') return TS_IDLE.indexOf(x.state) >= 0;
        if (S.tsFilter === 'onHand') return TS_ON_HAND.indexOf(x.state) >= 0;
        return true;
      } },
    ];
  }

  function sortTickets(items, p) {
    var keyed = items.map(function (x) {
      var clocks = clocksOf(x);
      var ours = TicketClocks.mostUrgent(clocks, p);
      return { t: x, clocks: clocks, ours: ours };
    });
    var cmp = {
      urgent: function (a, b) {
        var ra = a.ours ? a.ours.remainingMs : Infinity, rb = b.ours ? b.ours.remainingMs : Infinity;
        if (ra !== rb) return ra - rb;
        var ua = TicketClocks.isUnseen(a.t, p) ? 0 : 1, ub = TicketClocks.isUnseen(b.t, p) ? 0 : 1;
        return ua - ub || ms(a.t.createdAt) - ms(b.t.createdAt);
      },
      createdAsc: function (a, b) { return ms(a.t.createdAt) - ms(b.t.createdAt); },
      createdDesc: function (a, b) { return ms(b.t.createdAt) - ms(a.t.createdAt); },
      contact: function (a, b) {
        var ca = Math.max(ms(a.t.lastCustomerAt), ms(a.t.lastStaffPublicAt)), cb = Math.max(ms(b.t.lastCustomerAt), ms(b.t.lastStaffPublicAt));
        return cb - ca;
      },
    }[S.sort] || function () { return 0; };
    return keyed.sort(cmp);
  }

  function renderBoard() {
    var el = region('board');
    if (!el) return;
    if (!S.board) {
      el.innerHTML = '<div class="axp-empty">' + esc(t('loading')) + '</div>';
      return;
    }
    var p = S.view;
    var cols = columnsFor(p);
    var tabs = '<div class="axp-col-tabs" role="tablist">' + cols.map(function (c, i) {
      var n = S.board.tickets.filter(c.test).length;
      return '<button role="tab" aria-selected="' + (S.mobileCol === i) + '" data-act="mobileCol" data-i="' + i + '">' + esc(c.title) + ' <span class="axp-count">' + n + '</span></button>';
    }).join('') + '</div>';
    el.innerHTML = tabs + '<div class="axp-cols">' + cols.map(function (c, i) {
      var items = sortTickets(S.board.tickets.filter(c.test), p);
      var addBtn = c.key === 'intake' && p === 'cs' && PORTAL === 'cs' ? '<button class="axp-btn axp-btn-small" data-act="newIntake">' + esc(t('addIntake')) + '</button>' : '';
      var droppable = PORTAL === 'cs' && p === 'cs' && c.key === 'cs';
      return '<div class="axp-col' + (S.mobileCol === i ? ' is-current' : '') + '" data-col="' + c.key + '"' + (droppable ? ' data-drop="take"' : '') + '>' +
        '<div class="axp-col-head"><h3>' + esc(c.title) + ' <span class="axp-count">' + items.length + '</span></h3>' + addBtn + '</div>' +
        '<div class="axp-col-body">' + (items.length ? items.map(function (k) { return cardHtml(k, p); }).join('') : '<div class="axp-empty">' + esc(t('empty')) + '</div>') + '</div>' +
      '</div>';
    }).join('') + '</div>';
  }

  function cardHtml(k, p) {
    var x = k.t;
    var aura = auraOf(x, p, k.clocks);
    var cust = TicketClocks.mostUrgent(k.clocks, 'customer');
    var age = S.bh ? BizHours.format(S.bh.businessMsBetween(x.createdAt, now())) : '';
    var badges = '';
    if (x.refundPending) badges += '<span class="axp-badge axp-badge-refund">' + esc(t('badgeRefund')) + '</span>';
    if (x.unrepaired) badges += '<span class="axp-badge axp-badge-warn">' + esc(t('badgeUnrepaired')) + '</span>';
    if (x.outcome === 'unrepairable') badges += '<span class="axp-badge axp-badge-warn">' + esc(t('badgeUnrepairable')) + '</span>';
    if (x.outcome === 'no_issue') badges += '<span class="axp-badge">' + esc(t('badgeNoIssue')) + '</span>';
    if (x.outcome === 'extreme') badges += '<span class="axp-badge axp-badge-danger">' + esc(t('badgeExtreme')) + '</span>';
    if (x.filesRequestedAt) badges += '<span class="axp-badge axp-badge-files">' + esc(t('badgeFilesRequested')) + '</span>';
    if (p === 'cs' && holderOf(x.state) === 'ts') badges += '<span class="axp-badge axp-badge-action">' + esc(t('needsAction')) + '</span>';
    var draggable = PORTAL === 'cs' && p === 'cs' && x.state === 'CS_INTAKE';
    return '<article class="axp-card' + (aura ? ' aura-' + aura : '') + (S.selected === x.ticketId ? ' is-selected' : '') + '" tabindex="0" role="button"' +
        ' data-act="select" data-id="' + esc(x.ticketId) + '"' + (draggable ? ' draggable="true"' : '') + (aura ? ' title="' + esc(t('aura_' + aura)) + '"' : '') + '>' +
      '<div class="axp-card-top"><span class="axp-id">' + esc(x.ticketId) + '</span>' +
        '<span class="axp-contact" title="' + esc(x.contactMethod) + '">' + (CONTACT_ICONS[x.contactMethod] || '') + '</span>' +
        '<button class="axp-expand" data-act="full" data-id="' + esc(x.ticketId) + '" title="' + esc(t('openFull')) + '" aria-label="' + esc(t('openFull')) + '">⤢</button></div>' +
      '<div class="axp-card-title">' + esc(x.title) + '</div>' +
      '<div class="axp-card-desc">' + esc(x.descriptionPreview) + '</div>' +
      '<div class="axp-chips"><span class="axp-chip">' + esc(typeLabel(x)) + '</span>' +
        (x.state.indexOf('RMA_') === 0 ? '<span class="axp-chip axp-chip-state">' + esc(stateLabel(x.state)) + '</span>' : '') +
        (x.files ? '<span class="axp-chip" title="' + esc(t('logs')) + '">📁 ' + esc(x.files) + '</span>' : '') + badges + '</div>' +
      '<div class="axp-card-clock">' +
        (k.ours ? '<span class="axp-big' + (k.ours.overdue ? ' is-overdue' : k.ours.warn ? ' is-warn' : '') + '" title="' + esc(t('clock_' + k.ours.name)) + '">' + esc(fmtClock(k.ours)) + '</span>'
                : '<span class="axp-big is-none">' + esc(t('noClock')) + '</span>') +
        '<span class="axp-small">' + (cust ? esc(t('owner_customer')) + ' ' + esc(fmtClock(cust)) + ' · ' : '') + esc(t('age')) + ' ' + esc(age) + '</span>' +
      '</div>' +
    '</article>';
  }

  /* ───────────── rendering: detail ───────────── */

  function openTicket(id, full, push) {
    var changed = S.selected !== id;
    S.selected = id;
    S.full = !!full;
    S.form = null;
    S.editingTitle = false;
    if (changed) {
      S.detail = null;
      if (S.composer.ticketId !== id) S.composer = { mode: 'public', text: '', method: 'call', ticketId: id };
    }
    if (push !== false) {
      var url = new URL(location.href);
      if (full) url.searchParams.set('ticket', id); else url.searchParams.delete('ticket');
      setUrl(url, { ticket: full ? id : null }, false);
    }
    root.classList.toggle('axp-is-full', S.full);
    root.classList.add('axp-has-detail');
    renderBoard();
    return loadDetail(id);
  }

  function closeDetail(push) {
    S.selected = null;
    S.detail = null;
    S.full = false;
    root.classList.remove('axp-is-full', 'axp-has-detail');
    if (push !== false) {
      var url = new URL(location.href);
      if (url.searchParams.has('ticket')) {
        url.searchParams.delete('ticket');
        setUrl(url, { ticket: null }, false);
      }
    }
    renderBoard();
    renderDetail();
  }

  /** Full view → preview. Uses browser Back when we pushed the full view ourselves. */
  function leaveFull() {
    if (history.state && history.state.ticket) {
      history.back();
      return;
    }
    S.full = false;
    root.classList.remove('axp-is-full');
    var url = new URL(location.href);
    url.searchParams.delete('ticket');
    setUrl(url, {}, true);
    renderBoard();
    renderDetail();
  }

  function setUrl(url, state, replace) {
    try {
      if (replace) history.replaceState(state, '', url); else history.pushState(state, '', url);
    } catch (e) {
      // Some browsers refuse history changes on file:// pages; the deep link is just not updated.
    }
  }

  window.addEventListener('popstate', function () {
    if (!S.user) return;
    var id = new URLSearchParams(location.search).get('ticket');
    if (id) openTicket(id.toUpperCase(), true, false);
    else if (S.full) closeDetail(false);
  });

  /** Can the signed-in user act on this ticket from the board being shown? */
  function writable(tk) {
    return S.view === PORTAL && canWrite(tk, PORTAL);
  }

  /** Not writable, but the user can still leave an internal note (from either board). */
  function noteOnly(tk) {
    return !writable(tk) && canNote(tk, PORTAL);
  }

  function renderDetail() {
    var el = region('detail');
    if (!el) return;
    rememberComposer();
    if (!S.selected) {
      el.innerHTML = '<div class="axp-empty axp-detail-empty">' + esc(t('selectTicket')) + '</div>';
      return;
    }
    if (!S.detail || S.detailLoading) {
      el.innerHTML = detailTopBar(S.selected) + '<div class="axp-empty">' + esc(t('loading')) + '</div>';
      return;
    }
    var tk = S.detail;
    var canAct = S.view === PORTAL;
    var w = writable(tk);
    var n = noteOnly(tk);
    el.innerHTML =
      detailTopBar(tk.ticketId) +
      '<div class="axp-detail-body">' +
        '<div class="axp-detail-head">' +
          '<div class="axp-detail-id">' + esc(tk.ticketId) + ' <span class="axp-state">' + esc(stateLabel(tk.state)) + '</span>' +
            (tk.legacyId ? ' <span class="axp-chip">' + esc(tk.legacyId) + '</span>' : '') +
            ((tk.customerFiles || []).length || tk.filesRequestedAt ? ' <button class="axp-btn axp-btn-small" data-act="logs">📁 ' + esc(t('logs')) + ' (' + (tk.customerFiles || []).length + ')</button>' : '') + '</div>' +
          titleHtml(tk, w) +
          (tk.state === 'ARCHIVED' ? '<div class="axp-archived">' + esc(t('archivedReason', { r: t('reason_' + tk.archiveReason) })) + ' · ' + esc(fmtWhen(tk.archivedAt)) + '</div>' : '') +
          '<div class="axp-clocks" data-region="clocks">' + clocksHtml(tk) + '</div>' +
        '</div>' +
        (canAct ? actionsHtml(tk) : '') +
        (!w && tk.state !== 'ARCHIVED' && tk.state !== 'CS_INTAKE' ? '<div class="axp-readonly">' + esc(t('readOnly')) + ' — ' + esc(t(n ? 'readOnlyNotesOk' : 'readOnlyNote')) + '</div>' : '') +
        '<div class="axp-detail-grid">' +
          '<div class="axp-detail-main">' +
            '<h4>' + esc(t('timeline')) + '</h4>' +
            '<ol class="axp-timeline">' + timelineHtml(tk) + '</ol>' +
            (w ? composerHtml() : n ? noteComposerHtml() : '') +
          '</div>' +
          '<div class="axp-detail-side">' + depositHtml(tk) + filesRequestHtml(tk) + infoHtml(tk) + shipmentsHtml(tk) + paymentsHtml(tk) + '</div>' +
        '</div>' +
      '</div>';
    restoreComposer();
    var tl = el.querySelector('.axp-timeline');
    if (tl && tl.lastElementChild && S.full) tl.lastElementChild.scrollIntoView({ block: 'nearest' });
  }

  function detailTopBar(id) {
    return '<div class="axp-detail-bar">' +
      (S.full ? '<button class="axp-btn axp-btn-ghost" data-act="back">' + esc(t('back')) + '</button>'
              : '<button class="axp-btn axp-btn-ghost" data-act="full" data-id="' + esc(id) + '">⤢ ' + esc(t('openFull')) + '</button>') +
      '<button class="axp-btn axp-btn-ghost" data-act="closeDetail" aria-label="' + esc(t('close')) + '">✕</button>' +
    '</div>';
  }

  function titleHtml(tk, w) {
    if (S.editingTitle && w) {
      return '<form class="axp-title-form" data-form="title"><input name="title" maxlength="120" value="' + esc(tk.title) + '" required>' +
        '<button class="axp-btn axp-btn-primary axp-btn-small" type="submit">' + esc(t('save')) + '</button>' +
        '<button class="axp-btn axp-btn-small" type="button" data-act="cancelTitle">' + esc(t('cancel')) + '</button></form>';
    }
    return '<h2 class="axp-detail-title">' + esc(tk.title) +
      (w ? ' <button class="axp-icon-btn" data-act="editTitle" title="' + esc(t('editTitle')) + '" aria-label="' + esc(t('editTitle')) + '">✎</button>' : '') + '</h2>';
  }

  function clocksHtml(tk) {
    var clocks = clocksOf(tk);
    if (!clocks.length) return '';
    return clocks.map(function (c) {
      return '<div class="axp-clock' + (c.overdue ? ' is-overdue' : c.warn ? ' is-warn' : '') + (c.owner === 'customer' ? ' is-customer' : '') + '">' +
        '<span class="axp-clock-name">' + esc(t('clock_' + c.name)) + ' <em>(' + esc(t('owner_' + c.owner)) + ')</em></span>' +
        '<span class="axp-clock-value">' + esc(fmtClock(c)) + '</span>' +
        '<span class="axp-clock-due">' + esc(t('due')) + ' ' + esc(fmtWhen(c.deadline)) + '</span>' +
      '</div>';
    }).join('');
  }

  function renderClocks() {
    var el = root.querySelector('[data-region="clocks"]');
    if (el && S.detail) el.innerHTML = clocksHtml(S.detail);
  }

  /** Buttons for the current state (plan §4.3). TS buttons arrive in Phase 3. */
  function actionsHtml(tk) {
    var b = [];
    var id = esc(tk.ticketId);
    if (PORTAL === 'cs') {
      if (tk.state === 'CS_INTAKE') b.push(btn('take', t('take'), 'primary'));
      if (tk.state === 'CS_ACTIVE') b.push(btn('formSendToTs', t('sendToTs'), 'primary'));
      if (tk.state === 'CS_INTAKE' || tk.state === 'CS_ACTIVE') b.push(btn('formClose', t('closeTicket'), 'danger'));
      if (tk.refundPending) b.push(btn('formRefund', t('refundIssued'), 'primary'));
      if (tk.state === 'ARCHIVED') b.push(btn('formEditArchived', t('editTicket')));
    } else {
      var clocks = clocksOf(tk);
      var expired = function (name) { var c = TicketClocks.find(clocks, name); return !!(c && c.overdue); };
      switch (tk.state) {
        case 'TS_INTAKE':
          b.push(btn('rma', t('rma'), 'primary'), btn('formSendToCs', t('sendToCs')));
          if (!tk.filesRequestedAt) b.push(btn('formRequestFiles', t('requestFiles')));
          break;
        case 'RMA_AWAIT_DIAG_PAY':
          b.push(btn('formMarkPaid', t('markPaid'), 'primary'), btn('formSendToCs', t('sendToCs')));
          if (expired('diagPay')) b.push(btn('close', t('closeTicket'), 'danger'));
          break;
        case 'RMA_DIAG_PAID': b.push(btn('formTrackingIn', t('addInbound'), 'primary')); break;
        case 'RMA_INBOUND':
        case 'RMA_OUTBOUND': b.push(btn('markDelivered', t('markDelivered'), 'primary')); break;
        case 'RMA_ON_HAND':
          if (tk.reportUrl) {
            b.push('<a class="axp-btn axp-btn-primary" href="' + esc(tk.reportUrl) + '" target="_blank" rel="noopener">' + esc(t('fileReport')) + '</a>',
              btn('formReport', t('reportFallback'), 'ghost'));
          } else {
            b.push(btn('formReport', t('fileReport'), 'primary'));
          }
          break;
        case 'RMA_AWAIT_REPAIR_PAY':
          b.push(btn('formMarkPaid', t('markPaid'), 'primary'));
          if (expired('repairPay')) b.push(btn('returnUnrepaired', t('returnUnrepaired'), 'danger'));
          break;
        case 'RMA_REPAIR': b.push(btn('repairComplete', t('repairComplete'), 'primary')); break;
        case 'RMA_RETURN_PREP': b.push(btn('formTrackingOut', t('addOutbound'), 'primary')); break;
        default: break;
      }
    }
    if (tk.filesRequestedAt && writable(tk)) b.push(btn('cancelFilesRequest', t('cancelFilesRequest'), 'ghost'));
    var form = '';
    if (S.form && S.form.ticketId === tk.ticketId) {
      if (S.form.act === 'sendToTs') {
        form = '<form class="axp-inline-form" data-form="sendToTs"><label>' + esc(t('handoverNote')) + '<textarea name="note" rows="2"></textarea></label>' +
          formButtons() + '</form>';
      } else if (S.form.act === 'close') {
        var reply = TicketClocks.find(clocksOf(tk), 'customerReply');
        var pick = reply && reply.overdue ? 'no_reply' : 'resolved';
        form = '<form class="axp-inline-form" data-form="close"><p class="axp-muted">' + esc(t('closeHint')) + '</p>' +
          '<fieldset class="axp-fieldset"><legend>' + esc(t('closeReason')) + ' *</legend>' + ['resolved', 'no_reply', 'spam'].map(function (r) {
            return '<label class="axp-inline-radio"><input type="radio" name="reason" value="' + r + '" required' + (r === pick ? ' checked' : '') + '> ' + esc(t('close_' + r)) + '</label>';
          }).join('') + '</fieldset>' +
          '<label>' + esc(t('closeNote')) + '<textarea name="note" rows="2"></textarea></label>' +
          formButtons() + '</form>';
      } else if (S.form.act === 'editArchived') {
        var field = function (name, label, req, max, type) {
          return '<label>' + esc(t(label)) + (req ? ' *' : '') + '<input name="' + name + '" type="' + (type || 'text') + '" maxlength="' + max + '"' +
            (req ? ' required' : '') + ' value="' + esc(tk[name] || '') + '"></label>';
        };
        form = '<form class="axp-inline-form" data-form="editArchived"><p class="axp-muted">' + esc(t('editTicketHint')) + '</p>' +
          field('name', 'ed_name', true, 100) + field('email', 'ed_email', true, 200, 'email') + field('phone', 'ed_phone', false, 40, 'tel') +
          field('title', 'ed_title', true, 120) + field('vehicle', 'ed_vehicle', false, 200) +
          '<label>' + esc(t('outcome')) + '<select name="outcome">' + ['', 'warranty', 'damage', 'extreme', 'unrepairable', 'no_issue'].map(function (o) {
            return '<option value="' + o + '"' + (o === (tk.outcome || '') ? ' selected' : '') + '>' + esc(o ? t('outcome_' + o) : t('outcome_none')) + '</option>';
          }).join('') + '</select></label>' +
          '<label>' + esc(t('ed_reason')) + '<select name="archiveReason">' + ARCHIVE_REASONS.map(function (r) {
            return '<option value="' + r + '"' + (r === tk.archiveReason ? ' selected' : '') + '>' + esc(t('reason_' + r)) + '</option>';
          }).join('') + '</select></label>' +
          formButtons() + '</form>';
      } else if (S.form.act === 'requestFiles') {
        form = '<form class="axp-inline-form" data-form="requestFiles"><p class="axp-muted">' + esc(t('requestFilesHint')) + '</p>' +
          '<label>' + esc(t('requestFilesNote')) + '<textarea name="note" rows="2" maxlength="2000"></textarea></label>' +
          formButtons() + '</form>';
      } else if (S.form.act === 'refund') {
        form = '<form class="axp-inline-form" data-form="refund"><label>' + esc(t('refundRef')) + '<input name="refundRef" required maxlength="100"></label>' +
          formButtons() + '</form>';
      } else if (S.form.act === 'sendToCs') {
        form = '<form class="axp-inline-form" data-form="sendToCs"><label>' + esc(t('handoverNote')) + '<textarea name="note" rows="2"></textarea></label>' +
          formButtons() + '</form>';
      } else if (S.form.act === 'markPaid') {
        var kind = tk.state === 'RMA_AWAIT_DIAG_PAY' ? 'deposit' : tk.outcome === 'extreme' ? 'repair_extreme' : 'repair_normal';
        form = '<form class="axp-inline-form" data-form="markPaid"><input type="hidden" name="kind" value="' + kind + '">' +
          '<div><strong>' + esc(t('paymentKind')) + ':</strong> ' + esc(t('kind_' + kind)) + '</div>' +
          '<label>' + esc(t('orderNumber')) + '<input name="orderName" maxlength="40" placeholder="#1234"></label>' + formButtons() + '</form>';
      } else if (S.form.act === 'trackingIn' || S.form.act === 'trackingOut') {
        var inbound = S.form.act === 'trackingIn';
        form = '<form class="axp-inline-form" data-form="tracking" data-direction="' + (inbound ? 'in' : 'out') + '">' +
          '<label>' + esc(t('carrier')) + '<select name="carrier">' + CARRIERS.map(function (c) { return '<option>' + c + '</option>'; }).join('') + '</select></label>' +
          '<label>' + esc(t('trackingNumber')) + ' *<input name="tracking" required maxlength="40" autocomplete="off"></label>' +
          (inbound ? '<label>' + esc(t('labelPdf')) + '<input name="label" type="file" accept="application/pdf,.pdf"></label>' : '') +
          '<div class="axp-error" role="alert"></div>' + formButtons() + '</form>';
      } else if (S.form.act === 'editTracking') {
        var dir = tk.state === 'RMA_INBOUND' ? 'in' : 'out';
        var cur = (tk.shipments || []).filter(function (s) { return s.direction === dir && !s.deliveredAt; }).pop() || {};
        form = '<form class="axp-inline-form" data-form="editTracking"><p class="axp-muted">' + esc(t('editTrackingHint')) + '</p>' +
          '<label>' + esc(t('carrier')) + '<select name="carrier">' + CARRIERS.map(function (c) {
            return '<option' + (c === cur.carrier ? ' selected' : '') + '>' + c + '</option>';
          }).join('') + '</select></label>' +
          '<label>' + esc(t('trackingNumber')) + ' *<input name="tracking" required maxlength="40" autocomplete="off" value="' + esc(cur.tracking || '') + '"></label>' +
          formButtons() + '</form>';
      } else if (S.form.act === 'report') {
        form = '<form class="axp-inline-form" data-form="report"><p class="axp-muted">' + esc(t('reportInterim')) + '</p>' +
          '<fieldset class="axp-fieldset"><legend>' + esc(t('outcome')) + ' *</legend>' + ['warranty', 'damage', 'extreme', 'unrepairable', 'no_issue'].map(function (o) {
            return '<label class="axp-inline-radio"><input type="radio" name="outcome" value="' + o + '" required> ' + esc(t('outcome_' + o)) + '</label>';
          }).join('') + '</fieldset>' +
          '<label>' + esc(t('reportTitle')) + ' *<input name="title" required maxlength="120"></label>' +
          '<label>' + esc(t('findings')) + ' *<textarea name="findings" rows="4" required maxlength="10000"></textarea></label>' +
          formButtons() + '</form>';
      }
    }
    if (!b.length && !form) return '';
    var note = PORTAL === 'ts' && tk.state === 'RMA_ON_HAND' && tk.reportUrl ? '<p class="axp-muted">' + esc(t('reportPending')) + '</p>' : '';
    return '<div class="axp-actions" data-id="' + id + '">' + b.join('') + '</div>' + note + form;
  }

  function btn(act, label, kind) {
    return '<button class="axp-btn axp-btn-' + (kind || 'default') + '" data-act="' + act + '">' + esc(label) + '</button>';
  }

  function formButtons() {
    return '<div class="axp-form-buttons"><button class="axp-btn axp-btn-primary" type="submit">' + esc(t('confirm')) + '</button>' +
      '<button class="axp-btn" type="button" data-act="cancelForm">' + esc(t('cancel')) + '</button></div>';
  }

  function timelineHtml(tk) {
    var items = [];
    (tk.messages || []).forEach(function (m) { items.push({ at: m.at, m: m }); });
    (tk.events || []).forEach(function (e) { if (e.type !== 'seen') items.push({ at: e.at, e: e }); });
    items.sort(function (a, b) { return ms(a.at) - ms(b.at); });
    return items.map(function (it) {
      if (it.m) {
        var m = it.m;
        var cls = 'axp-msg axp-msg-' + m.authorType + (m.visibility === 'internal' ? ' is-internal' : '');
        var tag = m.visibility === 'internal' ? '<span class="axp-tag-internal">' + esc(t('internal')) + '</span>' : '';
        var logged = m.kind === 'log_contact' ? '<span class="axp-chip">' + (CONTACT_ICONS[m.contactMethod] || '') + ' ' + esc(t('logContact')) + '</span>' : '';
        return '<li class="' + cls + '"><div class="axp-msg-meta">' + tag + logged + '<strong>' + esc(m.authorName) + '</strong>' +
          (m.portal && m.authorType === 'staff' ? ' <span class="axp-muted">' + esc(m.portal.toUpperCase()) + '</span>' : '') +
          ' <time>' + esc(fmtWhen(m.at)) + '</time></div><div class="axp-msg-body">' + linkify(m.body) + '</div></li>';
      }
      var e = it.e;
      return '<li class="axp-event"><time>' + esc(fmtWhen(e.at)) + '</time> ' + esc(eventText(e)) + '</li>';
    }).join('');
  }

  function eventText(e) {
    var d = e.data || {};
    var detail = '';
    if (e.type === 'tracking_in' || e.type === 'tracking_out') detail = (d.carrier || '') + ' ' + (d.tracking || '');
    if (e.type === 'tracking_edited') detail = (d.from || '') + ' → ' + (d.to || '');
    if (e.type === 'refund_issued') detail = d.ref || '';
    if (e.type === 'payment_flagged') detail = (d.orderName || '') + ' (' + (d.kind || '') + ')';
    if (e.type === 'title_edited') detail = d.to || '';
    if (e.type === 'file_uploaded') detail = t('kind_' + d.kind) + ' ' + (d.name || '') + ' (' + fmtSize(d.bytes) + ')';
    if (e.type === 'edited' && d.changes) {
      detail = Object.keys(d.changes).map(function (k) {
        var label = function (v) { return !v ? '—' : k === 'outcome' ? t('outcome_' + v) : k === 'archiveReason' ? t('reason_' + v) : v; };
        return k + ': ' + label(d.changes[k][0]) + ' → ' + label(d.changes[k][1]);
      }).join(' · ');
    }
    if (e.type === 'report' && d.outcome) d = Object.assign({}, d, { outcome: t('outcome_' + d.outcome) });
    var s = ((EVENT_TEXT[S.lang] || EVENT_TEXT.en)[e.type] || e.type)
      .replace('{a}', who(e.actor)).replace('{p}', String(d.portal || '').toUpperCase()).replace('{d}', detail).replace('{o}', d.outcome || '');
    if (e.type === 'closed' && d.reason) s += ' — ' + t('reason_' + d.reason);
    return s;
  }

  function composerHtml() {
    var c = S.composer;
    var isNote = c.mode === 'internal';
    return '<form class="axp-composer' + (isNote ? ' is-internal' : '') + '" data-form="message">' +
      '<div class="axp-seg" role="radiogroup">' +
        '<button type="button" role="radio" aria-checked="' + !isNote + '" data-act="mode" data-mode="public">' + esc(t('replyToCustomer')) + '</button>' +
        '<button type="button" role="radio" aria-checked="' + isNote + '" data-act="mode" data-mode="internal">' + esc(t('internalNote')) + '</button>' +
      '</div>' +
      '<textarea name="body" rows="4" maxlength="10000" placeholder="' + esc(isNote ? t('writeNote') : t('writeReply')) + '"></textarea>' +
      '<div class="axp-composer-row">' +
        '<button class="axp-btn axp-btn-primary" type="submit">' + esc(t('send')) + '</button>' +
        '<span class="axp-composer-log" title="' + esc(t('logContactHint')) + '">' +
          '<select name="method" data-change="method">' + ['call', 'whatsapp', 'text', 'email'].map(function (mth) {
            return '<option value="' + mth + '"' + (c.method === mth ? ' selected' : '') + '>' + CONTACT_ICONS[mth] + ' ' + mth + '</option>';
          }).join('') + '</select>' +
          '<button class="axp-btn" type="button" data-act="logContact">' + esc(t('logContact')) + '</button>' +
        '</span>' +
      '</div>' +
    '</form>';
  }

  /** Internal-note-only composer for the other team's tickets. */
  function noteComposerHtml() {
    return '<form class="axp-composer is-internal" data-form="message" data-note-only="1">' +
      '<div class="axp-composer-label">' + esc(t('internalNote')) + '</div>' +
      '<textarea name="body" rows="3" maxlength="10000" placeholder="' + esc(t('writeNote')) + '"></textarea>' +
      '<div class="axp-composer-row">' +
        '<button class="axp-btn axp-btn-primary" type="submit">' + esc(t('send')) + '</button>' +
      '</div>' +
    '</form>';
  }

  var composerFocus = null;

  function rememberComposer() {
    var ta = root.querySelector('.axp-composer textarea');
    if (!ta) return;
    S.composer.text = ta.value;
    composerFocus = document.activeElement === ta ? [ta.selectionStart, ta.selectionEnd] : null;
  }

  function restoreComposer() {
    var ta = root.querySelector('.axp-composer textarea');
    if (!ta) return;
    ta.value = S.composer.text;
    if (composerFocus) {
      ta.focus();
      ta.setSelectionRange(composerFocus[0], composerFocus[1]);
    }
  }

  function infoHtml(tk) {
    var phoneDigits = String(tk.phone || '').replace(/[^\d+]/g, '');
    var rows = [
      [t('customer'), esc(tk.name)],
      [t('email'), '<a href="mailto:' + esc(tk.email) + '">' + esc(tk.email) + '</a>'],
      [t('phone'), tk.phone ? '<a href="tel:' + esc(phoneDigits) + '">' + esc(tk.phone) + '</a>' +
        (phoneDigits ? ' · <a href="https://wa.me/' + esc(phoneDigits.replace(/^\+/, '')) + '" target="_blank" rel="noopener">WhatsApp</a>' : '') : '—'],
      [t('language'), esc(tk.language === 'en' ? 'English' : 'Español')],
      [t('type'), esc((tk.inquiryType === 'sales' ? t('sales') : t('support')) + (tk.subCategory ? ' · ' + tk.subCategory : ''))],
      [t('vehicle'), esc(tk.vehicle || '—')],
      [t('contactMethod'), (CONTACT_ICONS[tk.contactMethod] || '') + ' ' + esc(tk.contactMethod) + (tk.source === 'staff' && tk.createdBy ? ' · ' + esc(who(tk.createdBy)) : '')],
      [t('created'), esc(fmtWhen(tk.createdAt))],
    ];
    if (tk.extra && typeof tk.extra === 'object') {
      Object.keys(tk.extra).forEach(function (k) { rows.push([k, esc(typeof tk.extra[k] === 'object' ? JSON.stringify(tk.extra[k]) : tk.extra[k])]); });
    }
    return '<section class="axp-panel"><h4>' + esc(t('details')) + '</h4><dl>' +
      rows.map(function (r) { return '<dt>' + esc(r[0]) + '</dt><dd>' + r[1] + '</dd>'; }).join('') + '</dl>' +
      '<h4>' + esc(t('description')) + '</h4><p class="axp-pre">' + esc(tk.description) + '</p></section>';
  }

  /** Files that arrived after the open request (the server closes it once both are in). */
  function filesRequestHtml(tk) {
    if (!tk.filesRequestedAt) return '';
    var since = ms(tk.filesRequestedAt);
    var got = function (kind) {
      return (tk.customerFiles || []).some(function (f) { return f.kind === kind && ms(f.uploadedAt) >= since; });
    };
    var line = function (kind) {
      return '<li>' + (got(kind) ? '✔ ' : '— ') + esc(t('kind_' + kind)) + ': ' + esc(t(got(kind) ? 'filesGot' : 'filesMissing')) + '</li>';
    };
    return '<section class="axp-panel axp-files-request"><h4>' + esc(t('filesRequest')) + '</h4>' +
      '<p class="axp-muted">' + esc(t('filesRequestedAt', { w: fmtWhen(tk.filesRequestedAt) })) + '</p>' +
      '<ul class="axp-list">' + line('tune') + line('log') + '</ul></section>';
  }

  function openLogsModal(tk) {
    var files = (tk.customerFiles || []).slice().sort(function (a, b) {
      return a.kind === b.kind ? ms(b.uploadedAt) - ms(a.uploadedAt) : a.kind === 'tune' ? -1 : 1;
    });
    var rows = files.map(function (f) {
      return '<li><span class="axp-chip">' + esc(t('kind_' + f.kind)) + '</span> ' +
        '<a href="https://drive.google.com/file/d/' + esc(f.fileId) + '/view" target="_blank" rel="noopener" title="' + esc(t('openDrive')) + '">' + esc(f.name) + '</a>' +
        '<br><span class="axp-muted">' + esc(fmtSize(f.bytes)) + ' · ' + esc(fmtWhen(f.uploadedAt)) +
        (f.ticketId !== tk.ticketId ? ' · ' + esc(t('fromTicket', { id: f.ticketId })) : '') + '</span></li>';
    }).join('');
    openModal(t('logsTitle', { e: tk.email }),
      (rows ? '<ul class="axp-list axp-files">' + rows + '</ul>' : '<p class="axp-empty">' + esc(t('noFiles')) + '</p>') +
      '<p class="axp-muted">' + esc(t('filesHeld')) + '</p>');
  }

  function depositHtml(tk) {
    if (!tk.payLink || tk.state !== 'RMA_AWAIT_DIAG_PAY') return '';
    var url = STORE_URL + tk.payLink;
    return '<section class="axp-panel"><h4>' + esc(t('depositLink')) + '</h4>' +
      '<div class="axp-copy-row"><input readonly value="' + esc(url) + '"><button class="axp-btn axp-btn-small" data-act="copy" data-value="' + esc(url) + '">' + esc(t('copy')) + '</button></div></section>';
  }

  function shipmentsHtml(tk) {
    if (!tk.shipments || !tk.shipments.length) return '';
    return '<section class="axp-panel"><h4>' + esc(t('shipments')) + '</h4><ul class="axp-list">' + tk.shipments.map(function (s) {
      var link = (CARRIER_LINKS[s.carrier] || CARRIER_LINKS.Auto) + encodeURIComponent(s.tracking);
      return '<li><strong>' + (s.direction === 'in' ? '→ AlphaX' : '→ ' + esc(tk.name)) + '</strong> · ' + esc(s.carrier) + ' ' +
        '<a href="' + esc(link) + '" target="_blank" rel="noopener">' + esc(s.tracking) + '</a> · ' + esc(s.status) +
        (s.lastEvent && !s.deliveredAt ? '<br><span class="axp-muted">' + esc(s.lastEvent) + '</span>' : '') +
        (s.deliveredAt ? ' · ' + esc(fmtWhen(s.deliveredAt)) : '') +
        (s.labelFileId ? ' · <a href="https://drive.google.com/file/d/' + esc(s.labelFileId) + '/view" target="_blank" rel="noopener">PDF</a>' : '') +
        (canEditTracking(tk, s) ? ' · <button class="axp-link axp-muted" data-act="formEditTracking">' + esc(t('editTracking')) + '</button>' : '') + '</li>';
    }).join('') + '</ul></section>';
  }

  /** The shipment still on its way, in the TS Portal only (rarely needed: fixes a typo). */
  function canEditTracking(tk, s) {
    var shipped = tk.state === 'ARCHIVED' && tk.archiveReason === 'shipped';
    var dir = tk.state === 'RMA_INBOUND' ? 'in' : tk.state === 'RMA_OUTBOUND' || shipped ? 'out' : '';
    return PORTAL === 'ts' && !!dir && s.direction === dir && !s.deliveredAt;
  }

  function paymentsHtml(tk) {
    if (!tk.payments || !tk.payments.length) return '';
    return '<section class="axp-panel"><h4>' + esc(t('payments')) + '</h4><ul class="axp-list">' + tk.payments.map(function (p) {
      return '<li>' + esc(p.kind) + ' · $' + esc(p.amount) + (p.orderName ? ' · ' + esc(p.orderName) : '') + ' · ' + esc(fmtWhen(p.paidAt)) + ' · ' + esc(p.matchedBy) + '</li>';
    }).join('') + '</ul></section>';
  }

  /* ───────────── modals ───────────── */

  function openModal(title, bodyHtml) {
    var host = region('modal');
    host.innerHTML = '<div class="axp-modal-backdrop" data-act="closeModal"></div>' +
      '<div class="axp-modal" role="dialog" aria-modal="true" aria-label="' + esc(title) + '">' +
        '<div class="axp-modal-head"><h3>' + esc(title) + '</h3><button class="axp-icon-btn" data-act="closeModal" aria-label="' + esc(t('close')) + '">✕</button></div>' +
        '<div class="axp-modal-body">' + bodyHtml + '</div></div>';
    var first = host.querySelector('input, select, textarea, button:not([data-act="closeModal"])');
    if (first) first.focus();
  }

  function closeModal() {
    var host = region('modal');
    if (host) host.innerHTML = '';
  }

  function openIntakeModal(prefill) {
    var p = prefill || {};
    var cats = Object.keys(SUBCATEGORIES).map(function (type) {
      return '<optgroup label="' + esc(t(type)) + '">' + SUBCATEGORIES[type].map(function (s) {
        return '<option value="' + type + '|' + esc(s) + '">' + esc(s) + '</option>';
      }).join('') + '</optgroup>';
    }).join('');
    openModal(t('newTicket'),
      '<form class="axp-form" data-form="intake">' +
        '<label>' + esc(t('methodOfContact')) + ' *<select name="contactMethod" required>' +
          '<option value="">—</option>' + ['email', 'whatsapp', 'text', 'call'].map(function (m) {
            return '<option value="' + m + '">' + CONTACT_ICONS[m] + ' ' + m + '</option>';
          }).join('') + '</select></label>' +
        '<label>' + esc(t('name')) + ' *<input name="name" required maxlength="100" value="' + esc(p.name) + '"></label>' +
        '<label>' + esc(t('email')) + ' *<input name="email" type="email" required maxlength="200" value="' + esc(p.email) + '"></label>' +
        '<label>' + esc(t('phone')) + ' <span class="axp-muted">(' + esc(t('optional')) + ')</span><input name="phone" maxlength="40" value="' + esc(p.phone) + '"></label>' +
        '<label>' + esc(t('language')) + '<select name="language"><option value="es">Español</option><option value="en">English</option></select></label>' +
        '<label>' + esc(t('inquiry')) + ' *<select name="category" required><option value="">—</option>' + cats + '</select></label>' +
        '<label>' + esc(t('vehicle')) + ' <span class="axp-muted">(' + esc(t('optional')) + ')</span><input name="vehicle" maxlength="200" value="' + esc(p.vehicle) + '"></label>' +
        '<label>' + esc(t('description')) + ' *<textarea name="description" rows="4" required maxlength="10000">' + esc(p.description) + '</textarea></label>' +
        '<div class="axp-error" role="alert"></div>' +
        '<div class="axp-form-buttons"><button class="axp-btn axp-btn-primary" type="submit">' + esc(t('create')) + '</button>' +
        '<button class="axp-btn" type="button" data-act="closeModal">' + esc(t('cancel')) + '</button></div>' +
      '</form>');
  }

  function openSearchModal(archivedOnly) {
    S.archivePage = 0;
    openModal(archivedOnly ? t('complete') : t('search'),
      '<form class="axp-search" data-form="search" data-archived="' + (archivedOnly ? '1' : '') + '">' +
        '<input name="q" type="search" placeholder="' + esc(t('searchPlaceholder')) + '" minlength="2">' +
        '<button class="axp-btn axp-btn-primary" type="submit">⌕</button></form>' +
      '<ul class="axp-results" data-region="results"></ul>' +
      (archivedOnly ? '<button class="axp-btn" data-act="archiveMore" hidden>' + esc(t('loadMore')) + '</button>' : ''));
    if (archivedOnly) loadArchivePage(0);
  }

  function resultRow(x) {
    return '<li><button class="axp-result" data-act="openResult" data-id="' + esc(x.ticketId) + '">' +
      '<span class="axp-id">' + esc(x.ticketId) + '</span> ' + (x.legacyId ? '<span class="axp-chip">' + esc(x.legacyId) + '</span> ' : '') +
      '<strong>' + esc(x.title) + '</strong> <span class="axp-muted">' + esc(x.name) + ' · ' + esc(stateLabel(x.state)) +
      (x.archiveReason ? ' · ' + esc(t('reason_' + x.archiveReason)) : '') + ' · ' + esc(fmtWhen(x.archivedAt || x.createdAt)) + '</span></button></li>';
  }

  function loadArchivePage(page) {
    api('archive.list', { portal: PORTAL, page: page, pageSize: 25 }).then(function (data) {
      var list = root.querySelector('[data-region="results"]');
      if (!list) return;
      if (page === 0) list.innerHTML = '';
      list.insertAdjacentHTML('beforeend', data.items.length || page ? data.items.map(resultRow).join('') : '<li class="axp-empty">' + esc(t('noResults')) + '</li>');
      S.archivePage = page;
      var more = root.querySelector('[data-act="archiveMore"]');
      if (more) more.hidden = (page + 1) * data.pageSize >= data.total;
    }).catch(function (err) { toast(err.message, 'error'); });
  }

  function openPasswordModal() {
    openModal(t('changePassword'),
      '<form class="axp-form" data-form="password">' +
        '<label>' + esc(t('currentPassword')) + '<input name="currentPassword" type="password" autocomplete="current-password" required></label>' +
        '<label>' + esc(t('newPassword')) + '<input name="newPassword" type="password" autocomplete="new-password" minlength="6" required></label>' +
        '<div class="axp-error" role="alert"></div>' +
        '<div class="axp-form-buttons"><button class="axp-btn axp-btn-primary" type="submit">' + esc(t('save')) + '</button></div>' +
      '</form>');
  }

  /** File → base64 (no data: prefix); resolves '' when there is no file. */
  function readBase64(file) {
    if (!file) return Promise.resolve('');
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () { resolve(String(reader.result).replace(/^data:[^,]*,/, '')); };
      reader.onerror = function () { reject(apiError(t('pdfOnly'), 'file')); };
      reader.readAsDataURL(file);
    });
  }

  /* ───────────── toasts ───────────── */

  function toast(message, kind) {
    var host = region('toasts');
    if (!host) return;
    var el = document.createElement('div');
    el.className = 'axp-toast axp-toast-' + (kind || 'info');
    el.textContent = message;
    host.appendChild(el);
    setTimeout(function () { el.remove(); }, 5000);
  }

  /* ───────────── events ───────────── */

  function setBusy(form, busy) {
    Array.prototype.forEach.call(form.querySelectorAll('button, input, select, textarea'), function (x) { x.disabled = busy; });
  }

  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-act]');
    if (!el || !root.contains(el)) return;
    var a = el.getAttribute('data-act');
    var id = el.getAttribute('data-id');
    var tk = S.detail;
    switch (a) {
      case 'lang':
        S.lang = S.lang === 'en' ? 'es' : 'en';
        ls.set('axp_lang', S.lang);
        if (S.user) { renderShell(); } else { renderLogin(); }
        break;
      case 'logout':
        api('auth.logout', {}).catch(function () {}).then(logoutLocal);
        break;
      case 'password': openPasswordModal(); break;
      case 'toggleView':
        S.view = S.view === PORTAL ? OTHER : PORTAL;
        S.mobileCol = 0;
        renderToolbar();
        renderBoard();
        renderDetail();
        break;
      case 'complete': openSearchModal(true); break;
      case 'search': openSearchModal(false); break;
      case 'archiveMore': loadArchivePage((S.archivePage || 0) + 1); break;
      case 'legend':
        S.legendOpen = !S.legendOpen;
        ls.set('axp_legend', S.legendOpen ? 'open' : 'closed');
        renderLegend();
        break;
      case 'mobileCol':
        S.mobileCol = Number(el.getAttribute('data-i')) || 0;
        renderBoard();
        break;
      case 'select':
        if (e.target.closest('[data-act="full"]')) return;
        openTicket(id, false, S.full);
        break;
      case 'full': openTicket(id, true, true); break;
      case 'back': leaveFull(); break;
      case 'closeDetail': closeDetail(true); break;
      case 'openResult':
        closeModal();
        openTicket(id, true, true);
        break;
      case 'closeModal': closeModal(); break;
      case 'newIntake': openIntakeModal(); break;
      case 'editTitle': S.editingTitle = true; renderDetail(); break;
      case 'cancelTitle': S.editingTitle = false; renderDetail(); break;
      case 'mode':
        rememberComposer();
        S.composer.mode = el.getAttribute('data-mode');
        renderDetail();
        break;
      case 'take':
        act('ticket.take', { ticketId: tk.ticketId, state: tk.state });
        break;
      case 'formSendToTs': S.form = { act: 'sendToTs', ticketId: tk.ticketId }; renderDetail(); break;
      case 'formClose': S.form = { act: 'close', ticketId: tk.ticketId }; renderDetail(); break;
      case 'formEditArchived': S.form = { act: 'editArchived', ticketId: tk.ticketId }; renderDetail(); break;
      case 'formRefund': S.form = { act: 'refund', ticketId: tk.ticketId }; renderDetail(); break;
      case 'formSendToCs': S.form = { act: 'sendToCs', ticketId: tk.ticketId }; renderDetail(); break;
      case 'formMarkPaid': S.form = { act: 'markPaid', ticketId: tk.ticketId }; renderDetail(); break;
      case 'formTrackingIn': S.form = { act: 'trackingIn', ticketId: tk.ticketId }; renderDetail(); break;
      case 'formTrackingOut': S.form = { act: 'trackingOut', ticketId: tk.ticketId }; renderDetail(); break;
      case 'formEditTracking': S.form = { act: 'editTracking', ticketId: tk.ticketId }; renderDetail(); break;
      case 'formReport': S.form = { act: 'report', ticketId: tk.ticketId }; renderDetail(); break;
      case 'formRequestFiles': S.form = { act: 'requestFiles', ticketId: tk.ticketId }; renderDetail(); break;
      case 'cancelFilesRequest':
        if (window.confirm(t('confirmCancelFiles', { id: tk.ticketId }))) act('ticket.cancelFilesRequest', { ticketId: tk.ticketId, state: tk.state });
        break;
      case 'logs': openLogsModal(tk); break;
      case 'rma':
        if (window.confirm(t('confirmRma', { id: tk.ticketId }))) act('ticket.rma', { ticketId: tk.ticketId, state: tk.state });
        break;
      case 'markDelivered':
        if (window.confirm(t('confirmDelivered', { id: tk.ticketId }))) act('ticket.markDelivered', { ticketId: tk.ticketId, state: tk.state });
        break;
      case 'repairComplete':
        if (window.confirm(t('confirmRepairComplete', { id: tk.ticketId }))) act('ticket.repairComplete', { ticketId: tk.ticketId, state: tk.state });
        break;
      case 'returnUnrepaired':
        if (window.confirm(t('confirmReturnUnrepaired', { id: tk.ticketId }))) act('ticket.returnUnrepaired', { ticketId: tk.ticketId, state: tk.state });
        break;
      case 'copy': {
        var value = el.getAttribute('data-value');
        var done = function () { toast(t('copied'), 'ok'); };
        if (navigator.clipboard) navigator.clipboard.writeText(value).then(done, function () {});
        break;
      }
      case 'cancelForm': S.form = null; renderDetail(); break;
      case 'close':
        if (window.confirm(t('confirmClose', { id: tk.ticketId }))) act('ticket.close', { ticketId: tk.ticketId, state: tk.state });
        break;
      case 'logContact': {
        var form = el.closest('form');
        var body = form.elements.body.value.trim();
        if (!body) { form.elements.body.focus(); return; }
        setBusy(form, true);
        act('ticket.message', { ticketId: tk.ticketId, kind: 'log_contact', contactMethod: form.elements.method.value, body: body })
          .then(function () { S.composer.text = ''; renderDetail(); }, function () { setBusy(form, false); });
        break;
      }
      default: break;
    }
  });

  root.addEventListener('dblclick', function (e) {
    var card = e.target.closest('.axp-card');
    if (card) openTicket(card.getAttribute('data-id'), true, true);
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && region('modal') && region('modal').innerHTML) { closeModal(); return; }
    var card = e.target.closest && e.target.closest('.axp-card');
    if (card && e.target === card && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      openTicket(card.getAttribute('data-id'), e.shiftKey, e.shiftKey || S.full);
    }
  });

  root.addEventListener('change', function (e) {
    var k = e.target.getAttribute('data-change');
    if (k === 'sort') {
      S.sort = e.target.value;
      if (S.user) ls.set('axp_sort_' + S.user.email, S.sort);
      renderBoard();
    } else if (k === 'tsFilter') {
      S.tsFilter = e.target.value;
      if (S.user) ls.set('axp_tsfilter_' + S.user.email, S.tsFilter);
      renderBoard();
    } else if (k === 'method') {
      S.composer.method = e.target.value;
    }
  });

  root.addEventListener('submit', function (e) {
    var form = e.target;
    var kind = form.getAttribute('data-form');
    if (!kind) return;
    e.preventDefault();
    var f = form.elements;
    var tk = S.detail;
    var errBox = form.querySelector('.axp-error');
    var fail = function (err) {
      setBusy(form, false);
      if (errBox) errBox.textContent = err.message;
    };

    if (kind === 'login') {
      setBusy(form, true);
      api('auth.login', { email: f.email.value, password: f.password.value }).then(function (data) {
        S.token = data.token;
        ss.set('axp_token_' + PORTAL, data.token);
        onLoggedIn(data.user);
      }, fail);
    } else if (kind === 'message') {
      var body = f.body.value.trim();
      if (!body) return;
      setBusy(form, true);
      var vis = form.getAttribute('data-note-only') ? 'internal' : S.composer.mode;
      act('ticket.message', { ticketId: tk.ticketId, visibility: vis, body: body })
        .then(function () { S.composer.text = ''; renderDetail(); }, function () { setBusy(form, false); });
    } else if (kind === 'title') {
      setBusy(form, true);
      act('ticket.editTitle', { ticketId: tk.ticketId, title: f.title.value })
        .then(function () { S.editingTitle = false; renderDetail(); }, function () { setBusy(form, false); });
    } else if (kind === 'sendToTs') {
      setBusy(form, true);
      act('ticket.sendToTs', { ticketId: tk.ticketId, state: tk.state, note: f.note.value })
        .then(function () { S.form = null; renderDetail(); }, function () { setBusy(form, false); });
    } else if (kind === 'requestFiles') {
      setBusy(form, true);
      act('ticket.requestFiles', { ticketId: tk.ticketId, state: tk.state, note: f.note.value })
        .then(function () { S.form = null; renderDetail(); }, function () { setBusy(form, false); });
    } else if (kind === 'refund') {
      setBusy(form, true);
      act('ticket.refundIssued', { ticketId: tk.ticketId, state: tk.state, refundRef: f.refundRef.value })
        .then(function () { S.form = null; renderDetail(); }, function () { setBusy(form, false); });
    } else if (kind === 'sendToCs') {
      setBusy(form, true);
      act('ticket.sendToCs', { ticketId: tk.ticketId, state: tk.state, note: f.note.value })
        .then(function () { S.form = null; renderDetail(); }, function () { setBusy(form, false); });
    } else if (kind === 'markPaid') {
      setBusy(form, true);
      act('ticket.markPaid', { ticketId: tk.ticketId, state: tk.state, kind: f.kind.value, orderName: f.orderName.value })
        .then(function () { S.form = null; renderDetail(); }, function () { setBusy(form, false); });
    } else if (kind === 'tracking') {
      var direction = form.getAttribute('data-direction');
      var file = f.label && f.label.files && f.label.files[0];
      if (file && (file.size > MAX_LABEL_BYTES || !/\.pdf$/i.test(file.name))) {
        errBox.textContent = t('pdfOnly');
        return;
      }
      setBusy(form, true);
      readBase64(file).then(function (labelBase64) {
        return act('ticket.addTracking', {
          ticketId: tk.ticketId, state: tk.state, direction: direction, carrier: f.carrier.value, tracking: f.tracking.value,
          labelBase64: labelBase64 || undefined,
        });
      }).then(function () { S.form = null; renderDetail(); }, function (err) { fail(err); });
    } else if (kind === 'close') {
      var reason = form.querySelector('input[name="reason"]:checked');
      if (!reason) return;
      setBusy(form, true);
      act('ticket.close', { ticketId: tk.ticketId, state: tk.state, reason: reason.value, note: f.note.value })
        .then(function () { S.form = null; renderDetail(); }, function () { setBusy(form, false); });
    } else if (kind === 'editArchived') {
      setBusy(form, true);
      act('ticket.editArchived', {
        ticketId: tk.ticketId, state: tk.state, name: f.name.value, email: f.email.value, phone: f.phone.value,
        title: f.title.value, vehicle: f.vehicle.value, outcome: f.outcome.value, archiveReason: f.archiveReason.value,
      }, t('editSaved')).then(function () { S.form = null; renderDetail(); }, function () { setBusy(form, false); });
    } else if (kind === 'editTracking') {
      setBusy(form, true);
      act('ticket.editTracking', { ticketId: tk.ticketId, state: tk.state, carrier: f.carrier.value, tracking: f.tracking.value })
        .then(function () { S.form = null; renderDetail(); }, function () { setBusy(form, false); });
    } else if (kind === 'report') {
      var outcome = form.querySelector('input[name="outcome"]:checked');
      if (!outcome) return;
      setBusy(form, true);
      act('ticket.report', { ticketId: tk.ticketId, state: tk.state, outcome: outcome.value, title: f.title.value, findings: f.findings.value })
        .then(function () { S.form = null; renderDetail(); }, function () { setBusy(form, false); });
    } else if (kind === 'intake') {
      var cat = f.category.value.split('|');
      setBusy(form, true);
      api('staff.createTicket', {
        portal: PORTAL, contactMethod: f.contactMethod.value, name: f.name.value, email: f.email.value, phone: f.phone.value,
        language: f.language.value, inquiryType: cat[0], subCategory: cat[1] || '', vehicle: f.vehicle.value, description: f.description.value,
      }).then(function (data) {
        closeModal();
        toast(t('created_ok', { id: data.ticketId }), 'ok');
        loadBoard().then(function () { openTicket(data.ticketId, false, S.full); });
      }, function (err) {
        setBusy(form, false);
        if (err.code === 'active_exists' && err.data && err.data.ticketId) {
          errBox.innerHTML = esc(t('activeExists', { id: err.data.ticketId })) +
            ' <button type="button" class="axp-link" data-act="openResult" data-id="' + esc(err.data.ticketId) + '">' + esc(t('openIt')) + '</button>';
        } else {
          errBox.textContent = err.message;
        }
      });
    } else if (kind === 'search') {
      var q = f.q.value.trim();
      var archivedOnly = form.getAttribute('data-archived') === '1';
      var list = root.querySelector('[data-region="results"]');
      if (archivedOnly && !q) { loadArchivePage(0); return; }
      if (q.length < 2) return;
      var more = root.querySelector('[data-act="archiveMore"]');
      if (more) more.hidden = true;
      list.innerHTML = '<li class="axp-empty">' + esc(t('loading')) + '</li>';
      api('search', { portal: PORTAL, q: q }).then(function (data) {
        var items = archivedOnly ? data.items.filter(function (x) { return x.state === 'ARCHIVED'; }) : data.items;
        list.innerHTML = items.length ? items.map(resultRow).join('') : '<li class="axp-empty">' + esc(t('noResults')) + '</li>';
      }, function (err) { list.innerHTML = '<li class="axp-error">' + esc(err.message) + '</li>'; });
    } else if (kind === 'password') {
      setBusy(form, true);
      api('auth.changePassword', { currentPassword: f.currentPassword.value, newPassword: f.newPassword.value }).then(function () {
        closeModal();
        toast(t('passwordChanged'), 'ok');
      }, fail);
    }
  });

  /* Drag a CS Intake card onto the CS column = Take ticket. */
  root.addEventListener('dragstart', function (e) {
    var card = e.target.closest && e.target.closest('.axp-card[draggable="true"]');
    if (!card) return;
    e.dataTransfer.setData('text/plain', card.getAttribute('data-id'));
    e.dataTransfer.effectAllowed = 'move';
    root.classList.add('axp-dragging');
  });
  root.addEventListener('dragend', function () {
    root.classList.remove('axp-dragging');
    Array.prototype.forEach.call(root.querySelectorAll('.is-drop-target'), function (x) { x.classList.remove('is-drop-target'); });
  });
  root.addEventListener('dragover', function (e) {
    var zone = e.target.closest && e.target.closest('[data-drop="take"]');
    if (!zone || !root.classList.contains('axp-dragging')) return;
    e.preventDefault();
    zone.classList.add('is-drop-target');
  });
  root.addEventListener('dragleave', function (e) {
    var zone = e.target.closest && e.target.closest('[data-drop="take"]');
    if (zone && !zone.contains(e.relatedTarget)) zone.classList.remove('is-drop-target');
  });
  root.addEventListener('drop', function (e) {
    var zone = e.target.closest && e.target.closest('[data-drop="take"]');
    if (!zone) return;
    e.preventDefault();
    zone.classList.remove('is-drop-target');
    var id = e.dataTransfer.getData('text/plain');
    var x = boardTicket(id);
    if (x && x.state === 'CS_INTAKE') {
      act('ticket.take', { ticketId: id, state: 'CS_INTAKE' }).then(function () { openTicket(id, false, S.full); }, function () {});
    }
  });

  boot();
})();
